import translation from "./translation";
import { amplifyAuthBaseEn, amplifyAuthBasePl } from "./amplifyAuthBase";

const baseByLang = {
  en: amplifyAuthBaseEn,
  pl: amplifyAuthBasePl,
};

const buildCustomOverrides = (lang) => {
  const t = translation[lang];

  return {
    Username: t.email,
    Email: t.email,
    Password: t.password,
    "Sign in": t.signIn,
    "Signing in": t.signingIn,
    "Show password": t.showPassword,
    "Hide password": t.hidePassword,
    "Back to Sign In": t.authBackToSignIn,
    "Confirm TOTP Code": t.authConfirmTotp,
    Code: t.authCode,
    "Code *": t.authCodeRequired,
    "Enter your Username": " ",
    "Enter your Password": " ",
    "Please confirm your Password": " ",
    "Incorrect username or password": t.authIncorrectCredentials.replace(/\.$/, ""),
    "Incorrect username or password.": t.authIncorrectCredentials.endsWith(".")
      ? t.authIncorrectCredentials
      : `${t.authIncorrectCredentials}.`,
    ...(t.authMessages || {}),
  };
};

const buildVocabulary = (lang) => ({
  ...baseByLang[lang],
  ...buildCustomOverrides(lang),
});

export const amplifyAuthVocabularies = {
  en: buildVocabulary("en"),
  pl: buildVocabulary("pl"),
};
